import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterTagged = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-tagged-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterTagged.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterTagged.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterTagged.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterTagged;
